<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Transaction Rules'"
      [canGoBack]="true"
      [noBow]="true"
      [linkIcon]="'information-circle-outline'"
      [linkIconSrc]="infoIconSrc"
      [showLinkIcon]="true"
      (linkAction)="showInfo()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (!loaded) {
      @for (i of [1,2,3]; track i) {
        <div class="finance-skeleton sk-card">
          <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
            <ion-skeleton-text [animated]="true" style="width: 35%; height: 12px; border-radius: 4px" />
            <ion-skeleton-text [animated]="true" style="width: 90px; height: 12px; border-radius: 4px" />
          </div>
          <ion-skeleton-text [animated]="true" style="width: 85%; height: 16px; border-radius: 4px; margin-bottom: 8px;" />
          <ion-skeleton-text [animated]="true" style="width: 55%; height: 16px; border-radius: 4px" />
        </div>
      }
      <ion-skeleton-text [animated]="true" style="width: 100%; height: 48px; border-radius: 24px; margin-top: 8px;" />
    }

    @if (loaded && ruleViews.length === 0) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No rules yet.'" />
        </tidy-row>
      </tidy-alert>
    }

    @if (loaded && ruleViews.length > 0) {
      <tidy-drag-drop
        dragDropId="transaction-rules-dd"
        [connectedDragDropsIds]="[]"
        [dataList]="ruleViews"
        [disabled]="reordering"
        emptyListMessage="No rules"
        emptyDisabledListMessage="No rules"
        (listDropped)="onReordered($event)">
        @for (view of ruleViews; track view.id; let i = $index) {
          <ng-container *tidyDragDropItem>
            <tidy-card style="width: 100%; cursor: grab;">
              <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
                <tidy-text
                  [helper]="'#' + (i + 1) + ' · ' + view.createdByLabel"
                  [translate]="false" />
                <div style="display: flex; gap: 12px;">
                  <tidy-text
                    [actionBody]="'Edit'"
                    (action)="editRule(view)"
                    class="link" />
                  <tidy-text
                    [actionBody]="'Delete'"
                    (action)="confirmDelete(view)"
                    class="link red" />
                </div>
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [body]="'When ' + view.conditionsLabel"
                  [translate]="false" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [heavyBody]="view.actionLabel"
                  [translate]="false" />
              </tidy-row>
            </tidy-card>
          </ng-container>
        }
      </tidy-drag-drop>
    }

    @if (loaded) {
      <tidy-button
        [text]="'New Rule'"
        [image]="'assets/img/add-button-white.svg'"
        [action]="boundNewRule"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
